import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import Loading from "../../based/Loading";

function CommonModal({ show, size, id, isBusy, busyMsg, classModalBody, hiddenFooter, customButton, error, title, onClose, children, onSave, isHideClose, onConfirm }) {
    return (
        <Modal show={show} size={size} id={id} enforceFocus={false}>
            <Loading show={isBusy ? isBusy : false} msg={busyMsg ? busyMsg : "Đang tải dữ liệu..."} />
            <Wrapper>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                    <button type="button cursor-pointer" className="btn-close-custom" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </Modal.Header>
                <Modal.Body className={classModalBody}>{children}</Modal.Body>
                {hiddenFooter ? null : (
                    <Modal.Footer>
                        {customButton ? customButton : null}
                        {onSave != undefined ? (
                            <button
                                className="btn btn-custom btn-sm"
                                onClick={() => {
                                    if (onSave) onSave();
                                }}
                            >
                                Lưu
                            </button>
                        ) : null}
                        {onConfirm != undefined ? (
                            <button
                                className="btn btn-confirm"
                                color="#4caf50"
                                onClick={() => {
                                    if (onConfirm) onConfirm();
                                }}
                            >
                                Xác nhận
                            </button>
                        ) : null}
                        {error ? (
                            <button className="btn btn-danger" onClick={onClose}>
                                Đóng
                            </button>
                        ) : onClose && !isHideClose ? (
                            <button className="btn btn-danger" onClick={onClose}>
                                Đóng
                            </button>
                        ) : null}
                    </Modal.Footer>
                )}
            </Wrapper>
        </Modal>
    );
}

export default CommonModal;

const Wrapper = styled.div`
    .modal-title {
        color: #333;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    button.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    button.btn-topup {
        border-radius: 40px;
        background: #28b259;
        border: none;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    button.btn-close-custom {
        border: none;
        background: none;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 !important;
    }
    .modal-header {
        display: flex;
        padding: 16px !important;
        background: #ff9027;
    }

    .modal-title {
        margin-left: auto !important;
        color: #fff !important;
        text-align: center;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }

    button.btn-close-custom {
        margin-left: auto;
    }

    .modal-body {
        padding: 10px !important;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    button.btn.btn-confirm {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    button.btn.btn-danger {
        border-radius: 40px;
        border: 1px solid #e5e5e5 !important;
        background: #f3f3f3 !important;
        color: #000 !important;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
`;

const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
